export enum PartnerQueryStatus
{
    New = 1,
    InProgress = 2,
    Responded = 3,
    ReOpened = 4,
    DeletedByPartner = 5,
    DeletedByRFCAdmin = 6
}


export enum QueryRequertTypeEnum
{
    MyQueryRequest = 1,
    AllQueryRequest
}